import { NgModule } from '@angular/core';
import { RouterModule, Routes } from "@angular/router";
import { InitialInterviewContainerComponent } from "./initial-interview-container/initial-interview-container.component";

const routes: Routes = [
  {
    path: '',
    component: InitialInterviewContainerComponent
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class InitialInterviewRoutingModule {
}
